import { ItemTypeActivitySearch } from '../types';

//order imported
const activityLinkToFormating = (item: Partial<ItemTypeActivitySearch>) => {
  const parts = [];

  if (item.accountNumber) {
    parts.push(item.accountNumber);
  }
  if (item.name) {
    parts.push(item.name);
  }
  if (item.usaAddress) {
    parts.push(item.usaAddress);
  }

  return parts.join(', ');
};
export default activityLinkToFormating;
